import { FileText, Loader } from "lucide-react";
import { Button } from "./button";

const ReportButton = ({ loading }: { loading: boolean }) => {
  return (
    <Button
      type="submit"
      className="flex items-center space-x-2 bg-primary-500 dark:bg-primary-400 text-white dark:hover:opacity-90"
      disabled={loading}
    >
      {loading ? (
        <Loader className="w-4 h-4 animate-spin" />
      ) : (
        <FileText className="w-4 h-4" />
      )}
      <span>Gerar relatório</span>
    </Button>
  );
};

export { ReportButton };
